namespace $.$$ {
	
	$mol_style_define( $shm_hitalama_vk_posts_plots_chart, {
		
		flex: {
			basis: '30rem',
		},

		Title: {
			padding: $mol_gap.text,
		},
		
	} )
	
}
